import ProductSystemPdfImageOverride from '@/models/ProductSystemPdfImageOverride';
import ProductSystemPdfImageOverrideRepository from '@/repositories/ProductSystemPdfImageOverrideRepository';

interface PdfImageOverride {
    id?: string;
    image: any[];
    config: any[];
    configString: string;
}

export async function saveProductSystemPdfImageOverrides(
    pdfImageOverrides: PdfImageOverride[],
    productSystemId: string
): Promise<void> {
    if (!pdfImageOverrides || pdfImageOverrides.length === 0) {
        return Promise.resolve();
    }

    // Get existing overrides for this product system
    const existingOverrides = ProductSystemPdfImageOverrideRepository.getByProductSystemId(productSystemId);
    const existingOverrideIds = existingOverrides.map((override) => override.id);

    // Track which existing overrides we've updated
    const updatedOverrideIds: string[] = [];

    // Create or update each override
    for (const override of pdfImageOverrides) {
        // Skip if no image uploaded
        if (!override.image || override.image.length === 0) {
            continue;
        }

        // Skip if config is empty
        if (!override.config || override.config.length === 0) {
            continue;
        }

        const pdfOfferImageId = override.image[0].uid;

        try {
            if (override.id) {
                // Update existing override
                await ProductSystemPdfImageOverride.updateExisting(
                    override.id,
                    override.config,
                    pdfOfferImageId,
                    productSystemId
                );
                updatedOverrideIds.push(override.id);
            } else {
                // Create new override
                const response = await ProductSystemPdfImageOverride.createNew(
                    override.config,
                    pdfOfferImageId,
                    productSystemId
                );
                if (response && response.data && response.data.id) {
                    updatedOverrideIds.push(response.data.id);
                }
            }
        } catch (e) {
            return Promise.reject(e);
        }
    }

    // Delete overrides that were removed
    const overridesToDelete = existingOverrideIds.filter((id) => !updatedOverrideIds.includes(id));
    for (const overrideId of overridesToDelete) {
        try {
            await ProductSystemPdfImageOverride.deleteExisting(overrideId);
        } catch (e) {
            // Continue even if delete fails
            console.error(`Failed to delete override ${overrideId}:`, e);
        }
    }

    return Promise.resolve();
}
